import "./License.css";
import { Card } from "react-bootstrap";
import AdminDashboardLayout from "../../../Components/AdminDashboard/AdminDashboardLayout";
import { useNavigate } from "react-router-dom";
import { useLocation, useParams } from "react-router-dom";
import SPCAD_Logo from '../../../assets/Logo/spcad_logo.png';
import Cadomation_Logo from '../../../assets/Logo/cadomation_logo.png';
import { useState, useEffect } from "react";
import axios from "axios";
import toast from "react-hot-toast";
import InvoiceTable from "../../../Components/Tables/Admin/InvoiceTable";
import Loading from 'react-fullscreen-loading';
import { FaUser, FaLock, FaGlobe } from 'react-icons/fa';
import { generatePDF } from "./GeneratePDF";


export default function LicenseInvoice() {
    const navigate = useNavigate();
    const [screenloader, setScreenloader] = useState(true);
    const [data, setData] = useState({});
    const [licenses, setLicenses] = useState([]);
    const Param1 = useParams();
    const location = useLocation();
    const loc = location.pathname === `/Admin/Licenses/Invoice/${Param1}` ? true : false;
    const id = Param1.id;

    useEffect(() => {
        getLicenseinfo();
    }, []);

    const getLicenseinfo = async () => {
        await axios.get(`${process.env.REACT_APP_API_URL}/admin/users/${id}/invoice`, {
            headers: {
                'access-token': localStorage.getItem('accessToken'),
            }
        })
            .then(res => {
                setScreenloader(false);
                if (res.data.status) {
                    if (res.data.data && res.data.data[0]) {
                        setData(res.data.data[0]);
                        if (res.data.data[0].licenses && res.data.data[0].licenses[0]) {
                            setLicenses(res.data.data[0].licenses);
                        }
                        return;
                    }
                } else if (res.data.status === false) {
                    toast.error('No invoice data found!');
                } else {
                    toast.error('Something Went Wrong');
                    console.log(res.data);
                    return;
                }
            })
            .catch(er => {
                setScreenloader(false);
                if (er.response.data?.message) {
                    toast.error(er.response.data?.message);
                    return;
                } else {
                    console.log(er);
                    toast.error("Something Went Wrong");
                    return;
                }
            });
    };
    return (
        <div>
            <AdminDashboardLayout />
            <Loading loading={screenloader} background="#fff" loaderColor="#883484" />

            <div className="content-page-bg">
                <div className="content-page">
                    <div className="content">
                        <Card className="invoice-card mt-2 shadow-lg border-0 mb-4">
                            <Card.Body>
                                {/* New Redesigned Header */}
                                <div className="row g-0 align-items-center mb-4">
                                    <div className="col-6 d-flex align-items-center">
                                        <img
                                            src={Cadomation_Logo}
                                            className="cad_Logo_new"
                                            alt="Cadomation Logo"
                                        />
                                        <div className="header-separator mx-3"></div>
                                        <img
                                            src={SPCAD_Logo}
                                            className="spcad_Logo_new"
                                            alt="SPCAD Logo"
                                        />
                                    </div>
                                    <div className="col-12 col-sm-6 mt-3 mt-sm-0 text-end">
                                        <h1 className="redesign-title m-0">LICENSING INFORMATION</h1>
                                        <p className="redesign-date m-0 mt-1">
                                            Issue Date: <strong>{new Date().toLocaleDateString('en-US', {
                                                year: 'numeric',
                                                month: 'long',
                                                day: 'numeric',
                                            })}</strong>
                                        </p>
                                    </div>
                                </div>

                                {/* New User Details Block */}
                                <div className="user-details-block mb-4 mt-5">
                                    <div className="row g-0">
                                        <div className="col-3 px-3">
                                            <label className="user-details-label">FULL NAME</label>
                                            <p className="user-details-value">{data.fname} {data.lname}</p>
                                        </div>
                                        <div className="col-3 px-3">
                                            <label className="user-details-label">EMAIL ADDRESS</label>
                                            <p className="user-details-value">{data.email}</p>
                                        </div>
                                        <div className="col-3 px-3">
                                            <label className="user-details-label">ORGANIZATION</label>
                                            <p className="user-details-value">{data.organization}</p>
                                        </div>
                                        <div className="col-3 px-3">
                                            <label className="user-details-label">COUNTRY</label>
                                            <p className="user-details-value">{data.country}</p>
                                        </div>
                                    </div>
                                </div>

                                {/* Licenses Issued Section */}
                                <div className="row g-0 mt-5">
                                    <InvoiceTable Data={licenses} />
                                </div>

                                <div className="redesign-footer mt-5 text-center">
                                    <p className="text-muted mb-2"><em>This system-generated document does not require signatures.</em></p>
                                    <p className="copyright-text mb-0">
                                        &copy; {new Date().getFullYear()} Cadomation. All rights reserved. | <a href="https://cadomation.com/" target="_blank" rel="noopener noreferrer" className="footer-link">www.cadomation.com</a>
                                    </p>
                                </div>
                            </Card.Body>
                        </Card>
                        {/* Download PDF Button */}
                        <div className="d-flex justify-content-end mt-3">
                            <button
                                onClick={generatePDF}
                                className="btn download-pdf-button"
                                style={{
                                    backgroundColor: "#2e2e67",
                                    color: "white",
                                    padding: "10px 20px",
                                    border: "none",
                                    borderRadius: "5px",
                                    cursor: "pointer",
                                    transition: "all 0.3s ease",
                                }}
                                onMouseEnter={(e) => e.target.style.backgroundColor = "#1d1d4b"}
                                onMouseLeave={(e) => e.target.style.backgroundColor = "#2e2e67"}
                            >
                                Download PDF
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
